import PendingTasksTableAction from './PendingTasksTableAction';

export default PendingTasksTableAction;
